// Import styles
import '../css/main.css';

import '@tailwindplus/elements';

// Import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';

/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
});

// Load Events
document.addEventListener('DOMContentLoaded', (): void => {
  routes.loadEvents();
});
